/* 🤖 this file was generated by svg-to-ts */
export const emperorIconInterfaceQuestionMark1: {
  name: 'interface_question_mark_1';
  data: string;
} = {
  name: 'interface_question_mark_1',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><path d="M12 2C6.48 2 2 6.487 2 12c0 5.51 4.48 10 10 10 5.51 0 10-4.49 10-10 0-5.513-4.49-10-10-10Zm0 16.25c-.69 0-1.25-.56-1.25-1.25s.56-1.25 1.25-1.25 1.25.56 1.25 1.25 -.56 1.25-1.25 1.25Zm1-4.38v1.12h-2v-3h1c1.1 0 2-.9 2-2 0-1.11-.9-2-2-2 -1.11 0-2 .89-2 2H8c0-2.205 1.795-4 4-4s4 1.795 4 4c0 1.86-1.28 3.42-3 3.87Z"/></svg>`
};
